import { IconYoutube } from './IconYoutube'

export default IconYoutube
